
import { Component, Vue } from 'vue-property-decorator';
import Pagination from '@/components/Pagination/index.vue';
import {
  getReservationClientList,
  cancelReservationClient,
  approvalReservationClient,
  downloadBusinessExcel,
} from '@/api/reservationClient';
import Refund from './components/refund.vue';
import moment from 'moment';

@Component({
  components: {
    Pagination,
    Refund,
  },
})
export default class extends Vue {
  mounted() {
    // this.handleDatePick('month');
    this.handleChangeDateRange();
    this.getReservationClientList();
  }

  private now = moment().format('YYYY-MM-DD');

  private listQuery: any = {
    page: 0,
    size: 10,
    searchType: 'name',
    searchValue: '',
    useStart: '',
    useEnd: '',
    searchDateType: 'createDate',
  }

  private dateRange: any = [];

  private totalElements = 0;

  private clientList: any = [];

  private loading = true;

  private refundFormVisible = false;

  private selectedClientUid = '';

  private getReservationClientList() {
    this.loading = true;
    getReservationClientList(this.listQuery).then((res) => {
      this.clientList = res.data.content;
      this.totalElements = res.data.totalElements;
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  }

  private handleSearch() {
    this.listQuery.page = 0;
    this.getReservationClientList();
  }

  /* eslint-disable */
  private handleChangeDateRange() {
    if (this.dateRange && this.dateRange.length === 2) {
      this.listQuery.useStart = this.dateRange[0];
      this.listQuery.useEnd = this.dateRange[1];
    } else {
      this.listQuery.useStart = '';
      this.listQuery.useEnd = '';
    }
  }
  /* eslint-enable */

  private handleCancel(client: any) {
    if (client.paymentStatus && client.price > 0) {
      this.refundFormVisible = !this.refundFormVisible;
      this.selectedClientUid = client.uid;
    } else {
      this.$confirm(`정말 ${client.itemName} 예약(${client.reservationCode})을 취소하시겠습니까?`, '예약 취소', {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
        type: 'warning',
      }).then(() => {
        cancelReservationClient(client.uid, {}).then(() => {
          this.$message.info('예약이 취소되었습니다.');
          client.status = -2;
        });
      });
    }
  }

  private alreadyCancel() {
    this.$message.warning('이미 취소되었습니다');
  }

  private closeRefundForm() {
    this.refundFormVisible = false;
  }

  private submitRefundForm() {
    this.closeRefundForm();
    this.handleSearch();
  }

  private handleClickView(client: any) {
    this.$router.push({ name: 'ReserveClientDetail', params: { uid: client.uid } });
  }

  private handleApproval(client: any) {
    this.$confirm('정말 예약을 승인하시겠습니까?', '예약 승인', {
      confirmButtonText: '확인',
      cancelButtonText: '취소',
      type: 'warning',
    }).then(() => {
      approvalReservationClient(client.uid, { approval: true }).then(() => {
        client.approvalStatus = true;
        this.$message.success('예약이 승인되었습니다.');
      });
    });
  }

  private handleDatePick(type: any) {
    if (type === 'day') {
      this.dateRange = [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
    } else if (type === 'week') {
      this.dateRange = [moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')];
    } else if (type === 'month') {
      this.dateRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')];
    } else if (type === 'year') {
      this.dateRange = [moment().startOf('year').format('YYYY-MM-DD'), moment().endOf('year').format('YYYY-MM-DD')];
    }
    this.handleChangeDateRange();
    this.listQuery.type = 0;
    this.handleSearch();
  }

  /* eslint-disable */
  private handleDownloadExcel() {
    downloadBusinessExcel(this.listQuery).then((res: any) => {
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const dateRange = (this.listQuery.useStart && this.listQuery.useEnd)
          ? `_${this.listQuery.useStart}~${this.listQuery.useEnd}` : '';
      link.setAttribute('download', `예약현황${dateRange}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }).catch(() => {
      this.$message.error('엑셀 다운로드에 실패했습니다.');
    });
  }
  /* eslint-enable */
}
